var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00195312H513V342.002H0V-0.00195312Z",
    fill: "#D80027",
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00195312H513V113.995H0V-0.00195312Z",
    fill: "black",
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.994H513V341.991H0V227.994Z",
    fill: "#FFDA44",
    rx: 5,
    ry: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    rx: 50,
    ry: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.5941fc27fbacb7deb3d53ccc20868b87.svg";
export { ForwardRef as ReactComponent };